import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { t } from "@/i18n";
import { Smile, Frown, Sparkles } from "lucide-react";

export default function LibraryPage() {
  const { lang } = useLang();
  const [data, setData] = useState({ feelings_met: {}, feelings_unmet: {}, needs: {} });

  useEffect(() => {
    api.get("/content/library").then((r) => setData(r.data));
    // Load once on mount; sections re-compute reactively from `lang`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const sections = [
    { icon: Smile, key: "feelings_met", items: data.feelings_met[lang] || [], tone: "primary" },
    { icon: Frown, key: "feelings_unmet", items: data.feelings_unmet[lang] || [], tone: "accent" },
    { icon: Sparkles, key: "needs", items: data.needs[lang] || [], tone: "primary" },
  ];

  return (
    <div className="space-y-10">
      <div>
        <div className="text-xs uppercase tracking-widest text-accent font-medium">{t(lang, "library")}</div>
        <h1 className="font-heading text-4xl font-light mt-2">{t(lang, "library")}</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">{t(lang, "library_intro")}</p>
      </div>

      {sections.map(({ icon: Icon, key, items, tone }) => (
        <div key={key} className="space-y-4">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${tone === "primary" ? "bg-secondary text-primary" : "bg-accent/20 text-accent"}`}>
              <Icon className="w-5 h-5" strokeWidth={1.5} />
            </div>
            <h2 className="font-heading text-2xl font-medium">{t(lang, key)}</h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid={`library-${key}`}>
            {items.map((it) => (
              <span key={it} className="px-4 py-2 rounded-full border border-border bg-card text-sm capitalize">
                {it}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
